import React, { Component } from "react";
import Helpers from "../../Utils/Helpers";


export default class CreateOrderTimeSlot extends Component {
    constructor(props){
        super(props);

        if(props.state && props.state.selectedTs)
            this.state = props.state;
        else {
            this.state = {
                selectedTs: []
            };
        }

        this.timeSlotsDuration = 6; // 6 hours

        this.slotsLabels = {
            0: "Nuit",
            6: "Matin",
            12: "Après-midi",
            18: "Soir"
        }
    }

    toggleTimeSlot = start => {
        const { selectedTs } = this.state;
        const { onSlotSelected } = this.props;

        const nbSelected = selectedTs.length;

        if(nbSelected === 0)
            selectedTs.push(start);
        else {
            const idx = selectedTs.indexOf(start);
            let min = Math.min(...selectedTs);
            let max = Math.max(...selectedTs);

            if(idx === -1){
                if(start < min)
                    min = start;
                if(start > max)
                    max = start;

                for(let i = min; i <= max; i += this.timeSlotsDuration){
                    if(selectedTs.indexOf(i) === -1)
                        selectedTs.push(i);
                }
            }
            else if (start === min || start === max)
                selectedTs.splice(idx, 1);
        }

        this.setState({ selectedTs }, () => {
            if(onSlotSelected){
                if(!selectedTs.length)
                    onSlotSelected(undefined, undefined, this.state);
                else{
                    onSlotSelected(
                        Math.min(...selectedTs), 
                        (Math.max(...selectedTs) + this.timeSlotsDuration), 
                        this.state
                    );
                }
            }
        });
    };

    renderTimeSlot = start => {
        let end = start + this.timeSlotsDuration;
        if(end === 24)
            end = 0;

        const { selectedTs } = this.state;
        const isSelected = selectedTs.indexOf(start) !== -1;
        const isPrevSelected = selectedTs.indexOf(start - this.timeSlotsDuration) !== -1;

        return <div 
            onClick={() => this.toggleTimeSlot(start)}
            className={`timeslot ${isSelected ? 'selected' : ''} ${isPrevSelected ? "" : "no-min"}`}
            key={`timeslot-${start}-${end}`} 
        >
            <div className="label" >
                { this.slotsLabels[start] || "" }<br />
                { Helpers.formatNumber(start, "00") }h &agrave; { Helpers.formatNumber(end, "00") }h
            </div>
        </div>;
    }

    render(){
        const D_ARRAY = Array.from({length: 24 / this.timeSlotsDuration}, (_, k) => k * this.timeSlotsDuration);

        return <div className="timeslot-selection-container">
            { D_ARRAY.map(this.renderTimeSlot) }
            <div className="last-filler-ts"></div>
            <div className="over"> </div>
        </div>;
    }
}

CreateOrderTimeSlot.defaultProps = {
    onSlotSelected: (min, max, state) => {},
    state: {}
};


// WEBPACK FOOTER //
// ./src/components/CreateOrder/TimeSlot.js